import classNames from "classnames";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import scrollTo from "PFCore/helpers/scroll_to";
import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import Engagement from "./engagement";
import css from "./paginated_exceptions_list.less";
import RolesList from "./roles_list";

const PaginatedExceptionsList = ({
  data,
  fetchData,
  tab,
  columns,
  fetchAllEngagements,
  workflowAutomation,
  roleFilters
}) => {
  const { engagementId, roleId } = useParams();
  const { t } = useTranslation("auditPlanner");

  const scrollToItem = useCallback((id) => {
    if (!window) {
      return;
    }

    const el = document.querySelector(`[data-scroll-key="${id}"]`);
    if (el) {
      scrollTo(window, 0, el.getBoundingClientRect().top + (window.pageYOffset || window.scrollY || 0) - 15);
    }
  }, []);

  useEffect(() => {
    if (engagementId) {
      scrollToItem(engagementId);
    }
  }, [roleId]);

  const noItems = data.entries.length === 0;

  return (
    <div className={classNames({ [css.loading]: data.loading })}>
      {noItems && <div className={css.noItems}>{t("parts.noEngagements")}</div>}
      {data.entries.map((item) => (
        <Engagement
          key={`${tab}_${item.id}`}
          engagement={item.activity}
          tab={tab}
          columns={columns}
          fetchAllEngagements={fetchAllEngagements}
          workflowAutomation={workflowAutomation}
          roleFilters={roleFilters}
        />
      ))}
      <SimplePagination
        currentPage={data.meta.page}
        handleClick={(number) => fetchData({ page: number })}
        totalPages={data.meta.totalPages}
      />
    </div>
  );
};

PaginatedExceptionsList.propTypes = {
  tab: PropTypes.string.isRequired,
  data: PropTypes.shape({
    entries: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
    loading: PropTypes.bool
  }).isRequired,
  columns: RolesList.propTypes.columns,
  fetchData: PropTypes.func.isRequired,
  fetchAllEngagements: PropTypes.func.isRequired,
  workflowAutomation: PropTypes.shape({
    auto_filling: PropTypes.number.isRequired,
    auto_shortlisting: PropTypes.number.isRequired,
    pending: PropTypes.number.isRequired
  }).isRequired,
  roleFilters: PropTypes.object
};

export default PaginatedExceptionsList;
